import { atom, useAtomValue } from "jotai";
import { atomFamily } from "jotai/utils";
import { deepEqual } from "./deepEqual";
const cacheAtom = atomFamily((key) => atom(new Intl.NumberFormat(key.locales, key.options)), deepEqual);
/**
 * Uses a cached number format instance for the given locales and options.
 * Comparison with deep equality
 * @param locales
 * @param options
 * @returns
 */
export function useCachedNumberFormat(locales, options) {
    return useAtomValue(cacheAtom({ locales, options }));
}
//# sourceMappingURL=useCachedNumberFormat.js.map